import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import StoriesMenu from '../components/stories/StoriesMenu.vue';
import StoriesList from '../components/stories/StoriesList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'StoriesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(StoriesMenu),
    _createVNode(StoriesList)
  ], 64))
}
}

})